module.exports = __webpack_public_path__ + "static/img/company_4.c381b98.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company_4.webp
// module id = k1cZ
// module chunks = 1